import { render, staticRenderFns } from "./AddressTabs.vue?vue&type=template&id=6cde3546&scoped=true"
import script from "./AddressTabs.vue?vue&type=script&lang=js"
export * from "./AddressTabs.vue?vue&type=script&lang=js"
import style0 from "./AddressTabs.vue?vue&type=style&index=0&id=6cde3546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde3546",
  null
  
)

export default component.exports